import React from "react";

/**
 * Section header — used above a group of cards or a table. Consistent
 * eyebrow + title + description + right-slot pattern.
 */
export default function SectionHeader({ eyebrow, title, description, right, testId }) {
  return (
    <div className="hbf-section-header" data-testid={testId || "section-header"}>
      <div>
        {eyebrow && <div className="hbf-eyebrow">{eyebrow}</div>}
        {title && <h2 className="hbf-h2" style={{ marginTop: eyebrow ? 6 : 0 }}>{title}</h2>}
        {description && <div className="hbf-section-header__desc hbf-muted">{description}</div>}
      </div>
      {right && <div className="hbf-section-header__right">{right}</div>}
    </div>
  );
}
